import React from 'react';
import 'bootstrap';
import 'aos'
import '../assets/css/style.css';
import '../assets/vendor/animate.css/animate.min.css';
import '../assets/vendor/aos/aos.css';
import '../assets/vendor/bootstrap/css/bootstrap.min.css';
import '../assets/vendor/bootstrap-icons/bootstrap-icons.css';
import '../assets/vendor/boxicons/css/boxicons.min.css';
import '../assets/vendor/glightbox/css/glightbox.min.css';
import '../assets/vendor/remixicon/remixicon.css';
import '../assets/vendor/swiper/swiper-bundle.min.css';
// import icon_1 from '../assets/img/Icons/rocket_saas.svg';
// import icon_2 from '../assets/img/Icons/arrow-6_saas.svg';
// import icon_3 from '../assets/img/Icons/ring_saas.webp';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';


const SaaSFrame = () => {
    
    return (<div className='portifoliobody'>
        <main id="main">
            <section id="saas" className="about text-start" style={{paddingTop:'0'}}>
                <div className='sf-main' data-aos="fade-up" data-aos-delay="200">
                    <div className='sf-section'>
                        <div className='sf-content'>
                            <div>
                                <div className='sf-title'>Lab Iconics LIMS-ELN (SaaS Model)</div>
                            </div>
                            <div>
                                <div className='sf-title-content'>Lab Iconics LIMS-ELN SaaS Model provides a cost-effective, scalable LIMS without the need for any IT infrastructure. With a pay-as-you-go model, labs can control costs and scale easily. Our cloud-based platform reduces expenses and enables quick deployment within 48 hours, allowing labs to focus on their work without any hassles.</div>
                            </div>
                            <div className='sf-points-section'>
                                <div>
                                    <ul className='sf-points-ul'>
                                        <li className='sf-points-li'> <b>Cost-Effective & Scalable - </b>LIMS-ELN SaaS model eliminates IT infrastructure, enabling labs to control costs, scale easily, and deploy within 48 hours.</li>
                                        <li className='sf-points-li'> <b>Seamless LIMS-ELN Integration - </b> Unifies sample tracking, workflow automation, and data management to reduce errors, optimize resources, and accelerate turnaround time.</li>
                                    </ul>
                                </div>
                                <div className='sf-points-ul-2'>
                                    <ul className='sf-points-ul'>
                                        <li className='sf-points-li-2'> <b>Centralized Lab Operations - </b>Integrates shared inventories, improves collaboration, reduces redundancy, and enhances compliance, streamlining workflows for optimized efficiency.</li>
                                    </ul>
                                </div>
                            </div>
                            <div className='learn-more-div' style={{padding:'20px', margin:'0'}}>
                                <Nav.Link as={Link} to='/saas' href='#LIMS' >
                                    <div className='learn-more-btn' style={{backgroundColor:'#bfd6e1',}}>
                                        <span>Explore</span>
                                        <div className="arrow arrow--right">
                                            <span></span>
                                        </div>
                                    </div>
                                </Nav.Link>
                            </div>
                            {/* <div className='rocket-icon'>
                                <div><img src={icon_1} alt="" /></div>
                            </div>
                            <div className='curve-arrow-icon'>
                                <div><img src={icon_2} alt=""/></div>
                            </div> */}
                            {/* <div className='coin-icon'>
                                <div><img src={icon_3} alt=""/></div>
                            </div> */}
                        </div>

                    </div>

                    
                </div>
            </section>
        </main>



    </div>

    );
};

export default SaaSFrame;